export const SET_INSTALLATION_MODAL_DISPLAYED_ON_FIRST_VISIT = `INSTALLATION_MODAL/SET_INSTALLATION_MODAL_DISPLAYED_ON_FIRST_VISIT`;

export const OPEN_INSTALLATION_MODAL = `INSTALLATION_MODAL/OPEN_INSTALLATION_MODAL`;

export const CLOSE_INSTALLATION_MODAL = `INSTALLATION_MODAL/CLOSE_INSTALLATION_MODAL`;
